"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIGridConstants = require("./UIGridConstants");

function makeBreakPointsType(range) {
  var rangePropType = _propTypes.default.oneOf(range);

  var screenSizeShapePropType = _propTypes.default.shape(_UIGridConstants.SCREEN_SIZES.reduce(function (shape, screenSize) {
    shape[screenSize] = rangePropType;
    return shape;
  }, {}));

  return _propTypes.default.oneOfType([_propTypes.default.string, // only intended for UIStepIndicator (#1753)
  rangePropType, screenSizeShapePropType]);
}

function breakPointsToClassName(classMap, breakPoints) {
  if (breakPoints == null) return null; // CRM-12024

  if (typeof breakPoints === 'string') {
    return null;
  }

  if (typeof breakPoints === 'number') {
    return classMap.xs[breakPoints];
  }

  return Object.keys(breakPoints).map(function (screenSize) {
    var value = breakPoints[screenSize];
    return "" + classMap[screenSize][value];
  }).join(' ');
}

var UIGridItem = (0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
      offset = _ref.offset,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className", "offset", "size"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)(className, breakPointsToClassName(_UIGridConstants.OFFSET_CLASSES, offset), breakPointsToClassName(_UIGridConstants.SIZE_CLASSES, size)),
    ref: ref
  }));
});
UIGridItem.propTypes = {
  children: _propTypes.default.node,
  offset: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired,
  size: makeBreakPointsType(_UIGridConstants.OFFSET_RANGE).isRequired
};
UIGridItem.defaultProps = {
  offset: 0
};
UIGridItem.displayName = 'UIGridItem';
var _default = UIGridItem;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/grid/UIGridItem.js
// module id = 95
// module chunks = 209 210 211 212